import storage from '@/utils/storage.js';
import utils from '@/utils/index.js';
function Swiper(el, flag) {
	this.$el = el;
    this.isDown = false;
	this.flag = flag;//表示是否需要遍历子元素去计算父容器的宽度
	// this.parent = el.parentNode;
	this.startPos = storage.getSession('startPos') || {};
	this.movePos = storage.getSession('movePos') || {};
	this.leftPos = storage.getSession('leftPos') || 0;
	this.maxLeftPos = 0;
	this.containerW = 0;
	this.boxW = 0;
    this.ua = utils.uaType();
	this.init();
}

Swiper.prototype = {
	init: function() {
		this.containerWidth();
        switch(this.ua) {
            case 'pc':
                this.$el.addEventListener('mousedown', this.mousedown.bind(this), false);
                this.$el.addEventListener('mousemove', this.mousemove.bind(this), false);
                this.$el.addEventListener('mouseup', this.mouseup.bind(this), false);
                this.$el.addEventListener('mouseleave', this.mouseleave.bind(this), false);
                break;
            case 'mobile':
                this.$el.addEventListener('touchstart', this.touchstart.bind(this), false);
                this.$el.addEventListener('touchmove', this.touchmove.bind(this), false);
                this.$el.addEventListener('touchend', this.touchend.bind(this), false);
                break;
        }
	},
	touchstart: function(e) {
        this.startPos = {
			x: e.touches[0].pageX,
			y: e.touches[0].pageY
		};
		storage.setSession('startPos', this.startPos);
	},
	touchmove: function(e) {
		e.preventDefault();
		this.movePos = {
			x: e.touches[0].pageX - this.startPos.x,
			y: e.touches[0].pageY - this.startPos.y
		};

		this.$el.style.webkitTransform = `translate(${this.limitMoveRange(this.leftPos + this.movePos.x)}px, 0)`;
		storage.setSession('movePos', this.movePos);
	},
	touchend: function() {
		this.leftPos = this.limitMoveRange(this.movePos.x + this.leftPos);
		storage.setSession('leftPos', this.leftPos);
	},
    mousedown: function(e) {
        this.isDown = true;
        this.startPos = {
			x: e.pageX,
			y: e.pageY
		};
		storage.setSession('startPos', this.startPos);
    },
    mousemove: function(e) {
        if(this.isDown) {
            this.movePos = {
                x: e.pageX - this.startPos.x,
                y: e.pageY - this.startPos.y
            };

            this.$el.style.webkitTransform = `translate(${this.limitMoveRange(this.leftPos + this.movePos.x)}px, 0)`;
			storage.setSession('movePos', this.movePos);
        }
    },
    mouseup: function() {
        this.isDown = false;
        this.leftPos = this.limitMoveRange(this.movePos.x + this.leftPos);
		storage.setSession('leftPos', this.leftPos);
    },
    mouseleave: function() {
        this.isDown = false;
        this.leftPos = this.limitMoveRange(this.movePos.x + this.leftPos);
		storage.setSession('leftPos', this.leftPos);
    },
	containerWidth: function() {
		let children = this.$el.children;
		let itemWidth = children[0].offsetWidth;
		let margin = parseInt(window.getComputedStyle(children[0], null).getPropertyValue('margin-right'));

		this.containerW = (this.flag ? this.mapChild([...children]) + 5 : itemWidth * children.length) + margin * children.length;
		// 这里的5表示计算宽度的大致误差
		this.$el.style.cssText = `width: ${this.containerW}px;${storage.getSession('navTransform')}`;

		this.boxW = this.$el.parentNode.offsetWidth;

		this.maxLeftPos = this.containerW - this.boxW;
	},
	mapChild: function(children) {
		let w = 0;
		children.map((item, index) => {
			w += item.offsetWidth;
		});
		return w;
	},
	limitMoveRange: function(value) {
		if(value >= 0) return 0;
		else if(Math.abs(value) >= this.maxLeftPos) return - (this.containerW - this.boxW);
		else return value;
	}
};

export default Swiper;


// WEBPACK FOOTER //
// ./src/utils/swiper.js